export default __webpack_public_path__ + "static/media/online-course.0798ef35.png";